/**
 * 
 * Table Field
 * 
 */

import React from 'react'
import PropTypes from 'prop-types'
// import BootstrapTable from 'react-bootstrap-table-next'
import { Label, FormGroup } from 'reactstrap'


function TableField(props) {
    const { label, name, value, required, style, metaData, options, onChange, tableColumns, labelStyle } = props

    const fieldOptions = options && Array.isArray(options) ? options : metaData && options && Object.keys(metaData).length > 0 && metaData[options] && metaData[options].length > 0 ? metaData[options] : []
    const fieldValues = value && Array.isArray(value) && value.length > 0 ? value : []

    const tableData = (fieldOptions || []).map(k => Object.assign({}, k, { action: fieldValues.find(d => d.companyId && k._id && d.companyId.toString() === k._id.toString()) && fieldValues.find(d => d.companyId && k._id && d.companyId.toString() === k._id.toString()).action }))

    return (
        <React.Fragment>
            <FormGroup className='no-margin'>
                <Label htmlFor={name} style={labelStyle}>{label} {required ? <span style={{ color: 'red' }}>*</span> : null}</Label>
                <div className='react-table-field'>
                    <table className="table table-bordered" style={style}>
                        <thead>
                            <tr>
                                {(tableColumns || []).map(t => (<td key={t.dataField}><b>{t.text}</b></td>))}
                            </tr>
                        </thead>
                        <tbody>
                            {tableData && tableData.length > 0 ? (tableData || []).map(d => (<tr key={d._id}>
                                {(tableColumns || []).map(b => (<td key={`${d._id}-${b.dataField}`}>{b.formatter && typeof b.formatter === 'function' ? b.formatter(d[b.dataField], onChange, fieldValues, d) : d[b.dataField]}</td>))}
                            </tr>)) : <tr>
                                <td>
                                    No Data Found
                                </td>
                            </tr>}
                        </tbody>
                    </table>
                </div>
            </FormGroup>
        </React.Fragment>
    )
}

TableField.propTypes = {
    t: PropTypes.any,
    label: PropTypes.string,
    value: PropTypes.string,
    name: PropTypes.string,
    onChange: PropTypes.func,
    placeholder: PropTypes.string,
    isInvalid: PropTypes.any,
    required: PropTypes.bool,
    style: PropTypes.object,
    disabled: PropTypes.any,
    metaData: PropTypes.object,
    options: PropTypes.any,
    tableColumns: PropTypes,
    labelStyle: PropTypes.object
}

export default TableField